import { Pipe, PipeTransform } from '@angular/core';
import { EnvironmentService } from '@libs/shared/common';

@Pipe({
  name: 'formatAbsolute',
})
export class FormatAbsolutePipe implements PipeTransform {
  public constructor(private readonly env: EnvironmentService) {
  }

  public transform(path: string): string {
    return `${this.env.app().baseHref}${path}`;
  }
}
